import React, { useEffect, useState, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { SurveyModal } from './components/ui/SurveyModal';
import { SurveyModalContext } from './hooks/use-survey-modal';
export function App() {
  const [isOpen, setIsOpen] = useState(false);
  // Inject tracking scripts (window-level checks prevent double-fire from StrictMode/hot reload)
  useEffect(() => {
    // HeatSnap tracker
    if (!(window as any).__heatsnap_loaded) {
      ;
      (window as any).__heatsnap_loaded = true;
      const hs = document.createElement('script');
      hs.src = 'https://heatmapsaas-zbdj9rd8.manus.space/tracker.js';
      hs.setAttribute('data-token', 'SO51aXA0MWJ-29cPen_sqG96cQi0WwEW');
      hs.async = true;
      document.body.appendChild(hs);
    }
    // Meta Pixel
    if (!(window as any).fbq) {
      ;
      (function (f: any, b: any, e: any, v: any) {
        var n: any, t: any, s: any;
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '878753891400350');
      (window as any).fbq('track', 'PageView');
      // noscript fallback
      const noscriptImg = document.createElement('img');
      noscriptImg.height = 1;
      noscriptImg.width = 1;
      noscriptImg.style.display = 'none';
      noscriptImg.src = 'https://www.facebook.com/tr?id=878753891400350&ev=PageView&noscript=1';
      document.body.appendChild(noscriptImg);
    }
    // Google Ads gtag.js
    if (!(window as any).gtag) {
      ;
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).gtag = function () {
        ;
        (window as any).dataLayer.push(arguments);
      };
      (window as any).gtag('js', new Date());
      (window as any).gtag('config', 'AW-17996213147');
      const gtagScript = document.createElement('script');
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17996213147';
      gtagScript.async = true;
      document.head.appendChild(gtagScript);
    }
  }, []);
  return <SurveyModalContext.Provider value={{
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  }} data-id="element-0">
      <LandingPage data-id="element-1" />
      <SurveyModal data-id="element-2" />
    </SurveyModalContext.Provider>;
}